module.exports = __webpack_public_path__ + "static/media/JTI.c3c64bd1.png";